import ApiServer from "./ApiServer.ts";
import FizConfig from "./FizConfig.ts";
import deviceId from "./lib/deviceId.ts";
import * as websocket from "./util/websocket.ts";
import * as i18n from "./i18n.ts";
import { loadScript } from "./lib/Async.ts";

var
  defaultRegister=function(onSuccess){if(onSuccess) onSuccess()},
  result : {register:Function} = {register:defaultRegister};

function sendTokenToServer(currentToken :string) :Promise<ApiServer.types.DeviceConfigBean>{
  return ApiServer.devicesetconfig(new ApiServer.types.DeviceConfigBean({
    "deviceId":deviceId,
    "notificationTokenId":currentToken,
    "modelType":'WebFirebase',
    "languageSystem":navigator.languages.join(', ').substring(0,45),
    "partnerType":FizConfig.CONFIG_PARTNER_TYPE,
    "applicationVersion":FizConfig.jsVersion,
    "systemName":navigator.platform.substring(0,500),
    "systemVersion":navigator.userAgent.substring(0,500)
  }));
}


async function initWebSocketNotification(){
  var permission = await Notification.requestPermission()
  console.log('permission '+permission)
  if (permission === "granted") {
    websocket.subscribe("AllPush",function(websocketPushMessageBean){
      console.log("pushed via websocket",websocketPushMessageBean)
      var
        data = websocketPushMessageBean.push,
        notification = new Notification(i18n.get("AppName"), {
          badge : FizConfig.CONFIG_PARTNER_TYPE+'/badge.svg',
          icon : data.authorIcon?(data.authorIcon.indexOf('data:')===0?data.authorIcon:data.authorIcon+'w=120&h=120&s=c'):FizConfig.CONFIG_PARTNER_TYPE+'/notification.png',
          data: data,
          image:data.image?data.image+"w=1024&h=1024&s=r":undefined,
          body : data.message
        });
      notification.onclick = function(event) {
        event.preventDefault();
        var
          url = "/home.php?push="+encodeURIComponent(data.messageType)+ (data.familyId?("&familyId="+encodeURIComponent(data.familyId)):"")+(data.targetId?("&targetId="+encodeURIComponent(data.targetId)):"");
        window.location.href = url;
      }
    });
  }

}

async function initFirebaseNotification(){
  try{
    await loadScript("https://www.gstatic.com/firebasejs/12.13.0/firebase-app-compat.js");
    await loadScript("https://www.gstatic.com/firebasejs/12.13.0/firebase-messaging-compat.js");

    window.firebase.initializeApp(FizConfig.firebase);
    const messaging = window.firebase.messaging();

    const permission = await Notification.requestPermission();
    if (permission !== "granted") {
      return;
    }

    // Try to get existing service worker registration first
    let registration = await navigator.serviceWorker.getRegistration('/');
    if (!registration) {
      // Only register if no service worker is already registered
      registration = await navigator.serviceWorker.register('/sw.php');
    }

    const token = await messaging.getToken({
      vapidKey: FizConfig.firebasevapikey,
      serviceWorkerRegistration: registration
    });
    sendTokenToServer(token);


  }catch(err){
    console.log('An error occurred while retrieving token. ', err);
    ApiServer.devicedelete(deviceId);
    initWebSocketNotification()
  }

}

//if we cannot have a fix deviceId we cannot use all this
if(!deviceId){
}else if(navigator.serviceWorker && FizConfig.serviceWorker && FizConfig.firebase){
  result.register = function(){
    //first of all do not register twice
    result.register = defaultRegister;
    //then wait 10s before launching notifications stuff
    setTimeout(initFirebaseNotification,10000);
  }

}else if (FizConfig.websocketNotification && "Notification" in window) {
  result.register = function(){
    //first of all do not register twice
    result.register = defaultRegister;
    initWebSocketNotification();
  }
}

export default result;